<img loading="lazy" [src]="src || fallbackImage" [alt]="alt" />
